import React from 'react'

const ValidationAlert = ({content}) => {
  return <small className="contact-form__error-message">{content}</small>
}

export default ValidationAlert